import { FormProvider, useForm } from "react-hook-form";

import { signup, SignupBody } from "@/api/endpoints/signup";
import { useMessages } from "@/containers/Messages/MessageContext";
import { serverErrorForHookForm } from "@/utils/forms";
import { useWizard } from "@components/Wizard";

const SignupForm = ({ children }: { children: React.ReactNode }) => {
  const { previous, next } = useWizard();
  const { danger } = useMessages();
  const methods = useForm<SignupBody>({ mode: "onBlur" });

  const onSubmit = (values: SignupBody) => {
    return signup(values).then((res) => {
      // Everything went fine, show the confirmation step
      if (res.status === 200) {
        next();
        return;
      }

      // If an error occurred, set the error message
      if (res.status === 400 && res.data) {
        const errors = serverErrorForHookForm<SignupBody>(res.data);
        errors.forEach(([str, error]) => methods.setError(str, error));

        // If any of the errors are for the name, email, or password fields, go back to the previous step
        // where these fields are located
        if (
          errors.some(([fieldName]) =>
            ["name", "email", "password"].includes(fieldName)
          )
        ) {
          previous();
        }
      } else {
        danger({
          title: L.SIGN_UP_UNKNOWN_ERROR,
          message: L.SIGN_UP_UNKNOWN_ERROR_MESSAGE,
        });
      }
    });
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>{children}</form>
    </FormProvider>
  );
};

export default SignupForm;
